'use client';

import React from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import { Button } from '@get-mosh/msh-shared';
import Heading from 'src/components/Heading/Heading';

import styles from './hero-card.module.scss';
import { Vertical } from 'src/constants/Verticals';
import { PrismicNextImage } from '@prismicio/next';

export type HeroCardProps = SliceComponentProps<Content.HeroCardSlice>;

const HeroCard = ({
    slice,
    context,
}: HeroCardProps & {
    context: { pageType: string };
}) => (
    <section className="container mx-auto py-8 lg:py-16 xl:max-w-screen-xl">
        <div className={styles['card']}>
            <div className={styles['card__img']}>
                <PrismicNextImage field={slice.primary.image} fill />
            </div>
            <div className={styles['card__content']}>
                <div className="flex flex-col space-y-4">
                    <div className={styles['card__title']}>
                        <Heading level="h1" tag="h">
                            {slice.primary.headline}
                        </Heading>
                    </div>
                    <ul className={styles['card__list']}>
                        {slice?.items?.map((item, i) => (
                            <li key={i}>
                                <FontAwesomeIcon icon={faCircleCheck} />
                                {item.list_item}
                            </li>
                        ))}
                    </ul>
                </div>
                {slice.primary.cta && slice.primary.path && (
                    <Button
                        text={slice.primary.cta}
                        as="a"
                        href={slice.primary.path}
                        onClick={() => {
                            trackClick(EventNames.BUTTON_CLICKED, {
                                pageType: context.pageType,
                                vertical: slice.primary.vertical as Vertical,
                                label: slice.primary.cta as string,
                                link: slice.primary.path as string,
                                variation: slice.variation,
                                location: slice.slice_type,
                            });
                        }}
                        className={styles['card__btn']}
                    />
                )}
            </div>
        </div>
    </section>
);

export default HeroCard;
